export default {
  ATTENDANCE: 'attendance',
  POINT_REWARD: 'point_reward',
  LEAVE: 'leave',
  OVERTIME: 'overtime',
  MANAGEMENT: 'management',
}